export default __webpack_public_path__ + "static/media/36I-117142_-43589_0.c5cbfdc8.jpg";